import { Property } from 'csstype';

export type GridProps = {
  gridColumn?: Property.GridColumn;
};

const gridItemInterpolations = {
  gridColumn: ({ gridColumn }: Pick<GridProps, 'gridColumn'>) =>
    gridColumn === undefined
      ? {}
      : {
          gridColumn
        }
};

export { gridItemInterpolations };
